import script from "./pwa-menu-panel-settings.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./pwa-menu-panel-settings.vue?vue&type=script&setup=true&lang=ts"
export * from "./pwa-menu-panel-settings.vue.ts?vue&type=script&setup=true&lang=ts!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./pwa-menu-panel-settings.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__